"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _transitions = require("../styles/transitions");

var _useForkRef = _interopRequireDefault(require("../utils/useForkRef"));

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-param-reassign */
var setStyles = function setStyles(node, style, transitionDuration) {
  var s = typeof style === 'function' ? style(node) : style;
  var keys = Object.keys(s);

  if (transitionDuration) {
    node.style.transition = (0, _transitions.createTransition)(keys, {
      duration: transitionDuration
    });
  }

  keys.forEach(function (key) {
    node.style[key] = s[key];
  });
};
/* eslint-enable no-param-reassign */

/**
 * Transition helps make a UI expressive and easy to use.
 * This is a helper component that enables us to provide initial and final state.
 */


var Transition = _react["default"].forwardRef(function Transition(props, forwardedRef) {
  var children = props.children,
      inProp = props["in"],
      appearProp = props.appear,
      timeoutProp = props.timeout,
      style = props.style,
      onEnter = props.onEnter,
      onExit = props.onExit,
      unmountOnExit = props.unmountOnExit;
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(appearProp),
      appear = _useState[0],
      setAppear = _useState[1];

  (0, _react.useEffect)(function () {
    if (!appear) {
      setAppear(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var _useState2 = (0, _react.useState)(inProp),
      inVal = _useState2[0],
      setInVal = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var node = ref.current;

    if (!node) {
      return undefined;
    }

    var timeout;

    if (inProp) {
      var duration = typeof timeoutProp === 'object' ? timeoutProp.enter : timeoutProp;

      if (appear) {
        setStyles(node, style.exit);
      }

      if (!unmountOnExit) {
        setStyles(node, {
          visibility: ''
        });
      }

      setTimeout(function () {
        setStyles(node, style.enter, duration);
        setInVal(true);

        if (onEnter) {
          timeout = setTimeout(function () {
            onEnter();
          }, duration);
        }
      }, 0);
    } else {
      var _duration = typeof timeoutProp === 'object' ? timeoutProp.exit : timeoutProp;

      setStyles(node, style.enter);
      setStyles(node, style.exit, _duration);
      timeout = setTimeout(function () {
        setInVal(false);

        if (!unmountOnExit) {
          setStyles(node, {
            visibility: 'hidden'
          });
        }

        if (onExit) {
          onExit();
        }
      }, _duration);
    }

    return function () {
      return clearTimeout(timeout);
    };
  }, [inProp, style]); // eslint-disable-line react-hooks/exhaustive-deps
  // at this moment it doesn't cause any bugs, so, we're not worrird about exhaustive-deps xd

  var handleRef = (0, _useForkRef["default"])(ref, forwardedRef); // if not in=false, prevent initial appearing

  (0, _react.useLayoutEffect)(function () {
    var node = ref.current;

    if (!node) {
      return;
    }

    if (!unmountOnExit && !inVal) {
      setStyles(node, {
        visibility: 'hidden'
      });
    }
  }, [unmountOnExit, inVal]);

  if (!inVal && !inProp && unmountOnExit) {
    return null;
  }

  var child = _react["default"].Children.only(children);

  return _react["default"].cloneElement(child, {
    ref: handleRef
  });
});

Transition.propTypes = {
  // children is a single child content element.
  // needs to be able to hold a ref.
  children: _propTypes["default"].element.isRequired,
  timeout: _types.timeoutType,
  "in": _propTypes["default"].bool,
  appear: _propTypes["default"].bool,
  onEnter: _propTypes["default"].func,
  onExit: _propTypes["default"].func,
  unmountOnExit: _propTypes["default"].bool,
  style: _propTypes["default"].shape({
    enter: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
    exit: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func])
  })
};
Transition.defaultProps = {
  appear: true,
  timeout: 200,
  unmountOnExit: true
};
Transition.hiName = 'Transition';
var _default = Transition;
exports["default"] = _default;